import dotty from './images/dotty.png'
import sophie from './images/sophie.png'
import cassie from './images/cassie.png'
import finley from './images/finley.png'
import tiggy from './images/tiggy.png'
import lizzie from './images/lizzie.png'
import livvie from './images/livvie.png'
import tasha from './images/tasha.png'
import vaino from './images/vaino.png'

const Data = [
  {
    'id': '1',
    'name': 'Dotty',
    'bday' : 'June 16',
    'animal' : 'Leopard, Wild cat',
    'family' : 'Beanie Boos',
    'poem': 'If you stare at my bold colored spots / They might start to look like big crazy dots !',
    'url' : dotty,
    'price' : '8.99'
  },
  {
    'id': '2',
    'name': 'Sophie',
    'bday' : 'January 13',
    'animal' : 'Cat',
    'family' : 'Beanie Boos',
    'poem': 'Meow is what I mostly say / In the yard is where I play.',
    'url' : sophie,
    'price' : '3.99'
  },
  {
    'id': '3',
    'name': 'Cassie',
    'bday' : 'December 12',
    'animal' : 'Cat',
    'family' : 'Teeny Tys',
    'poem': null,
    'url' : cassie,
    'price' : '5.99'
  },
  {
    'id': '4',
    'name': 'Finley',
    'bday' : 'February 11',
    'animal' : 'Fox',
    'family' : 'Teeny Tys',
    'poem': null,
    'url' : finley,
    'price' : '5.99'
  },
  {
    'id': '5',
    'name': 'Tiggy',
    'bday' : 'April 16',
    'animal' : 'Tiger, Wild cat',
    'family' : 'Teeny Tys',
    'poem': null,
    'url' : tiggy,
    'price' : '5.99'
  },
  {
    'id': '6',
    'name': 'Lizzie',
    'bday' : 'September 21',
    'animal' : 'Leopard, Wild cat',
    'family' : 'Beanie Boos',
    'poem': 'I\'m the coolest leopard that you will ever see / And you can always find me sitting in a tree !',
    'url' : lizzie,
    'price' : '8.99'
  },
  {
    'id': '7',
    'name': 'Livvie',
    'bday' : 'August 8',
    'animal' : 'Leopard, Wild cat',
    'family' : 'Beanie Boos',
    'poem': 'I\'m on the prowl for a friend just like you / Side by side, there is nothing we can\'t do !',
    'url' : livvie,
    'price' : '3.99'
  },
  {
    'id': '8',
    'name': 'Tasha',
    'bday' : 'January 4',
    'animal' : 'Leopard, Wild cat',
    'family' : 'Beanie Boos',
    'poem': 'You\'ll not see me during the day / Because my spots help me to hide away.',
    'url' : tasha,
    'price' : '8.99'
  },
  {
    'id': '9',
    'name': 'Väinö',
    'bday' : 'December 6',
    'animal' : 'Moose',
    'family' : 'Beanie Boos',
    'poem': 'My horns are my crown / And the forest - my home / I\'m wild and free / That\'s all I want to be!',
    'url' : vaino,
    'price' : '8.99'
  },
]

export default Data